import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap } from './router.config.js'
import store from '@/store'
import { getToken } from '@/api/token'
import { setValue, getValue } from '@/utils/storage'
// hack router push callback
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const createRouter = () =>
  new Router({
    mode: 'history', // 如果你是 history模式 需要配置vue.config.js publicPath
    // base: process.env.BASE_URL,
    scrollBehavior: () => ({ y: 0 }),
    routes: [...constantRouterMap]
  })
const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
}
router.beforeEach(async (to, from, next) => {
  let visitNo = ''
  let patientNo = ''
  if (window.location.search) {
    const serchParams = new URLSearchParams(window.location.search);
    visitNo = serchParams.get('visitNo')
    patientNo = serchParams.get('patientNo')
    if (visitNo && patientNo) {
      setValue('visitNo', visitNo)
      setValue('patientNo', patientNo)
    }
  }
  if (store.state.token.token) {
    next()
  } else {
    const visitNo = getValue('visitNo') || ''
    const patientNo = getValue('patientNo') || ''
    const result = await getToken(visitNo, patientNo)
    if (result.code === 200) {
      store.commit('setToken', result.token)
      store.commit('setVisitNo', visitNo)
      store.commit('setPatientId', result.patientId)
      next()
    }
  }
  // next()
})
export default router
